export const OVERVIEW_NO_DATA_TEXT = '—';

export const OVERVIEW_ZERO_COUNT_TEXT = '0';

export const START_BUTTON_LABEL = 'Start an AI process';
